"use client";
import * as React from "react";
const SvgPaymentRound = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 14", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M14.4.5H1.6C.71.5 0 1.22 0 2.13v9.75c0 .9.71 1.62 1.6 1.62h12.8c.89 0 1.6-.72 1.6-1.62V2.12c0-.9-.71-1.62-1.6-1.62m-.8 11.38H2.4a.8.8 0 0 1-.8-.82V7h12.8v4.06a.8.8 0 0 1-.8.81m.8-8.12H1.6v-.81a.8.8 0 0 1 .8-.82h11.2c.44 0 .8.37.8.82z" }));
export {
  SvgPaymentRound as default
};
